// FORK range-input2.js ze Zbrani
// samostatny range input, ktery je nutne inicializovat (viz dole)

import $ from "jquery";
import VOID from "./framework/framework";

const _ = VOID._;

const Model = VOID.ExtendableObject.extend({
  constructor: function (opts) {
    this.opts = opts;
  },

  // min in model space
  getMin: function () {
    return this.opts.min;
  },

  // max in model space
  getMax: function () {
    return this.opts.max;
  },

  // visual min in model space
  getVisualMin: function () {
    return this.opts.visualMin;
  },

  // visual max in model space
  getVisualMax: function () {
    return this.opts.visualMax;
  },

  // model -> view space
  toViewSpace: function () {
    throw "toViewSpace not implemented";
  },

  // view -> model space
  fromViewSpace: function () {
    throw "fromViewSpace not implemented";
  },

  // view -> view space
  clampViewSpace: function (val) {
    return this.toViewSpace(this.fromViewSpace(val));
  },

  // model space -> input value
  formatInputValue: function (val) {
    return val;
  },

  // model space -> string
  format: function (val) {
    return "" + val;
  },

  round: function(val) {
    const precision = Math.max(0, -Math.floor(log10(this.opts.step)));
    return +val.toFixed(precision);
  }
});
//=============================================================================
const LinearModel = Model.extend({
  constructor: function (opts) {
    this.opts = opts;
    if (!this.opts.postfix) this.opts.postfix = '';
  },
  toViewSpace: function (val) {
    // scale
    const visualMin = this.getVisualMin();
    const range = this.getVisualMax() - visualMin;
    return (+val - visualMin) / range;
  },

  fromViewSpace: function (val) {
    val = +val;

    // keep extremes un-rounded

    if (val <= 0) return this.getVisualMin();
    if (val >= 1) return this.getVisualMax();

    // scale

    const visualMin = this.getVisualMin();
    const range = this.getVisualMax() - visualMin;
    val = visualMin + val * range;

    // snap

    val = Math.round(+val / this.opts.step) * this.opts.step;

    // clamp

    const min = this.getMin();
    const max = this.getMax();

    return val < min ? min : val > max ? max : val;
  },

  format: function (val) {
    return val + this.opts.postfix;
  }

});

//=============================================================================
function log10(val) { // IE nepodporuje Math.log10
  return Math.log(val)/Math.log(10);
}

const PriceModel = Model.extend({ // Samovina, pouze s odstranenymi warnings (let/const, ===)
  constructor: function (opts) {
    this.opts = opts;
    if (!this.opts.postfix) this.opts.postfix = ' Kč';
    this.logRozsah = log10(+this.getVisualMax() + 1) - log10(+this.getVisualMin() + 1);
    this.logCorrection = 5000.0 / this.logRozsah;
    if (this.logCorrection < 1) this.logCorrection = 1;
    this.precision = (('' + this.opts.step).indexOf('.') !== -1) ? (('' + this.opts.step).length - ('' + this.opts.step).indexOf('.') - 1) : 0; // for min/max clamping purposes
    this.minPrecision = (('' + this.getMin()).indexOf('.') !== -1) ? (('' + this.getMin()).length - ('' + this.getMin()).indexOf('.') - 1) : 0; // for min/max clamping purposes
    this.maxPrecision = (('' + this.getMax()).indexOf('.') !== -1) ? (('' + this.getMax()).length - ('' + this.getMax()).indexOf('.') - 1) : 0; // for min/max clamping purposes
  },
  myLog: function (val) {
    return Math.log(val + this.logCorrection);
  },
  myExp: function (val) {
    return Math.exp(val) - this.logCorrection;
  },

  toViewSpace: function (val) {
    // scale
    val = +val;
    const visualMin = this.getVisualMin();
    const visualMax = this.getVisualMax();
    return (this.myLog(val) - this.myLog(visualMin)) / (this.myLog(visualMax) - this.myLog(visualMin));

  },

  fromViewSpace: function (val) {
    val = +val;
    const visualMin = this.getVisualMin();
    const visualMax = this.getVisualMax();
    val = this.myExp(val * (this.myLog(visualMax) - this.myLog(visualMin)) + this.myLog(visualMin));

    // snap
    const min = this.getMin();
    const max = this.getMax();

    if (+val.toFixed(this.minPrecision) < Math.ceil(visualMin / this.opts.step) * this.opts.step) return min;
    if (+val.toFixed(this.maxPrecision) > Math.floor(visualMax / this.opts.step) * this.opts.step) return max;

    val = Math.round(val / this.opts.step) * this.opts.step;

    // clamp

    return val < min ? min : val > max ? max : val;
  },

  formatInputValue: function (val) {
    val = +val.toFixed(this.precision); // round
    const fract = val - Math.floor(val);
    return fract ? val.toFixed(this.precision) : val.toFixed(0);
  },

  format: function (val) {
    val = +val.toFixed(2); // round
    const fract = val - Math.floor(val);
    val = '' + Math.floor(val);
    const arr = val.split("").reverse();
    const out = [];
    let j = 0;
    for (let i = 0; i < arr.length; i++) {
      out.unshift(arr[i]);
      const isDot = arr[i + 1] === ".";
      if ((j % 3) === 2 && i !== arr.length - 1 && !isDot) out.unshift('.');
      if (!isDot) j++;
    }
    val = out.join("") + (fract ? (',' + ('' + fract.toFixed(2)).substr(2)) : '');
    return val + this.opts.postfix;
//      return val;
  }
});
//=============================================================================
const PinView = VOID.View.extend({
  getName: VOID.utils.constant("range_pin"),

  getTemplateName: VOID.utils.constant("range_pin"),

  handleMounted: function () {
    VOID.utils.drag({
      el: this.references.pin,
      onStart: evt => {
        this.indicateDrag(true);
        this.emit("dragstart", {evt});
      },
      onMove: evt => {
        this.emit("dragmove", {evt});
      },
      onEnd: evt => {
        this.indicateDrag(false);
        this.emit("dragend", {evt});
      }
    });
  },

  setOffset: function (val) {
    this.references.pin.style.left = (val * 100) + "%";
  },

  indicateDrag: function (state) {
    $(this.references.pin).toggleClass("dragged", state);
  }
});
//=============================================================================
export const RangeInputView = VOID.View.extend({
  init: function () {
    this.fromInput = this.opts.fromInput;
    this.toInput = this.opts.toInput;

    this.from = this.model.toViewSpace(this.fromInput.value);
    this.to = this.model.toViewSpace(this.toInput.value);

    this.preventTrackClick = false;

    this.registerSubview(new VOID.BasicView(), "from");
    this.registerSubview(new VOID.BasicView(), "to");

    this.registerSubview(new PinView(null, this.opts), "pin_from");
    this.registerSubview(new PinView(null, this.opts), "pin_to");
  },

  getName: VOID.utils.constant("range_input"),

  getTemplateName: VOID.utils.constant("range_input"),

  getTemplateData: function () {
    return {
      min: this.model.format(this.model.getVisualMin()),
      max: this.model.format(this.model.getVisualMax())
    };
  },

  handleMounted: function () {
    const toViewSpace = px => px / this.references.pins.offsetWidth;

    const fromPinView = this.subviews.pin_from[0];
    const toPinView = this.subviews.pin_to[0];

    // "from" pin
    let fromStart;

    this.listenTo(fromPinView, "dragstart", () => {
      fromStart = this.from;
      this.preventTrackClick = true;
    });

    this.listenTo(fromPinView, "dragmove", evt => {
      this.setFrom(fromStart + toViewSpace(evt.evt.deltaX));
    });

    const enableTrackClickDelayed = () => {
      setTimeout(() => { this.preventTrackClick = false; }, 0);
    };

    this.listenTo(fromPinView, "dragend", () => {
      if (this.model.fromViewSpace(fromStart) !== this.model.fromViewSpace(this.from)) {
        this.emit("change");
      }
      enableTrackClickDelayed();
    });

    // "to" pin
    let toStart;

    this.listenTo(toPinView, "dragstart", () => {
      toStart = this.to;
      this.preventTrackClick = true;
    });

    this.listenTo(toPinView, "dragmove", evt => {
      this.setTo(toStart + toViewSpace(evt.evt.deltaX));
    });

    this.listenTo(toPinView, "dragend", () => {
      if (this.model.fromViewSpace(toStart) !== this.model.fromViewSpace(this.to)) {
        this.emit("change");
      }
      enableTrackClickDelayed();
    });

    // track click
    this.references.track.addEventListener("click", evt => {
      if (this.preventTrackClick) return;
      const totalLength = this.references.pins.offsetWidth;
      const val = (evt.clientX - this.references.pins.getBoundingClientRect().left) / totalLength;
      if (val < this.from) {
        this.setFrom(val);
        this.emit("change");
      } else if (val > this.to) {
        this.setTo(val);
        this.emit("change");
      }
    });

    // first sync
    this.update();
  },

  setFrom: function (val) {
    // TODO: spacing between from and to?
    const prev = this.from;
    this.from = this.model.clampViewSpace(val < 0 ? 0 : val > this.to ? this.to : val);
    if (this.from !== prev) this.update();
  },

  setTo: function (val) {
    // TODO: spacing between from and to?
    const prev = this.to;
    this.to = this.model.clampViewSpace(val > 1 ? 1 : val < this.from ? this.from : val);
    if (this.to !== prev) this.update();
  },

  update: function () {
    // model space values
    const modelFrom = this.model.fromViewSpace(this.from);
    const modelTo = this.model.fromViewSpace(this.to);

    // view space values
    const viewFrom = this.from;
    const viewTo = this.to;

    // pin positions
    this.subviews.pin_from[0].setOffset(viewFrom);
    this.subviews.pin_to[0].setOffset(viewTo);

    // range left/right
    if (this.references.range) {
      this.references.range.style.left = (this.from * 100) + "%";
      this.references.range.style.right = ((1 - this.to) * 100) + "%";
    }

    // strings
    this.subviews.from[0].setText(this.model.format(modelFrom));
    this.subviews.to[0].setText(this.model.format(modelTo));

    // min/max classes
    if (this.references.min) $(this.references.min).toggleClass("set", modelFrom > this.model.getMin());
    if (this.references.max) $(this.references.max).toggleClass("set", modelTo < this.model.getMax());

    // tooltip position
    if (this.references.value) this.references.value.style.left = ((this.from + this.to) / 2 * 100) + "%";

    // input values
    console.log("flow 1", modelFrom, modelTo);
    this.fromInput.value = this.model.formatInputValue(modelFrom);
    this.toInput.value = this.model.formatInputValue(modelTo);
  }
});

RangeInputView.PriceModel = PriceModel;
RangeInputView.LinearModel = RangeInputView.TimeModel = LinearModel;

// auto inicializace z data atributu

const TEMPLATE_NAME = "rangeInputTemplate";

const autoInitTypes = [
  { kw: "linear", model: LinearModel },
  { kw: "price", model: PriceModel },
];

for (const {kw, model: Model} of autoInitTypes) {
  const DATA_ATTR = `data-range-input-${kw}`;
  const ELEMENT_FLAG_PROPERTY = `__${kw}RangeInputInited`;

  function initRangeInputs() {
    $(`[${DATA_ATTR}]`).each(function () {
      const el = this;

      if (el[ELEMENT_FLAG_PROPERTY]) return;

      const $el = $(el);

      let opts;
      try {
        opts = JSON.parse($el.attr(DATA_ATTR));
      } catch (e) {
        console.error("initRangeInputs failed to initialize element", el, e);
        return;
      }

      // two hidden inputs that get sent
      const $from = $el.find(".js-range-slider-group-from");
      const $to = $el.find(".js-range-slider-group-to");

      const min = (!opts.adjust || $from.val() === "") ? +opts.min : Math.min(+$from.val(), +opts.min);
      const max = (!opts.adjust || $to.val() === "") ? +opts.max : Math.max(+$to.val(), +opts.max);

      console.log("flow 0", min, max);

      const form = $el.closest("form").get(0);
      const slider = $el.find(".js-range-slider-group-slider").get(0);

      // two visual inputs that don't get sent
      const $fromVisual = $el.find(".js-range-slider-group-from-visual");
      const $toVisual = $el.find(".js-range-slider-group-to-visual");

      const model = new Model({
        min,
        max,
        visualMin: min,
        visualMax: max,
        step: +opts.step
      });

      const view = new RangeInputView(model, {
        template: TEMPLATE_NAME,
        fromInput: $fromVisual.get(0),
        toInput: $toVisual.get(0)
      });

      const submit = _.boundArgs(AJAX, "handleSubmit", form);
      // const submitDebounced = _.debounce(submit, 400);

      const updateHiddenInputs = () => {
        const from = model.round(model.fromViewSpace(view.from));
        const to = model.round(model.fromViewSpace(view.to));

        // hidden inputs should be empty if in extreme value
        $from.val(view.from <= 0 ? "" : from);
        $to.val(view.to >= 1 ? "" : to);
      };

      // update input values
      view.on('change', () => {
        updateHiddenInputs();
        submit();
      });

      // update sliders instantly on change
      const makeChangeHandler = (prop, setter) => function () {
        const valUnclamped = model.toViewSpace(+this.value);
        const val = model.clampViewSpace(valUnclamped);
        if (val !== view[prop]) {
          setter(val);
          updateHiddenInputs();
          submit();
        } else if (val !== valUnclamped) {
          this.value = model.formatInputValue(model.fromViewSpace(val));
        }
      };

      $fromVisual.on("change", makeChangeHandler("from", _.bound(view, "setFrom")));
      $toVisual.on("change", makeChangeHandler("to", _.bound(view, "setTo")));

      view.appendTo(slider);

      el[ELEMENT_FLAG_PROPERTY] = true;
    });
  }

  $(initRangeInputs);
  AJAX.onUpdate(initRangeInputs);
}
